import { DistributionType, FeatureType } from '@aviv-search/types';
import { getLegacyEstateTypes } from './getLegacyEstateTypes';
import { getProjectTypeLegacy } from './getProjectTypeLegacy';
import { getTransactionType } from './getTransactionType';
const roundPrice = (price, isRent) => {
    if (!price)
        return undefined;
    const roundingValue = isRent ? 100 : 10000;
    return Math.trunc(price / roundingValue) * roundingValue;
};
export const getTargetingFr = ({ props: { geoHierarchy, searchModel }, adSlot: { id: adSlotId }, }) => {
    if (!searchModel && !geoHierarchy)
        return [];
    const isRent = searchModel?.distributionTypes?.includes(DistributionType.RENT) ?? false;
    return [
        { key: 'pos', value: adSlotId },
        // Geo targeting
        { key: 'localite', value: geoHierarchy?.municipality?.administrativeCode },
        { key: 'cp', value: geoHierarchy?.mainPostalCode },
        { key: 'geoDp', value: geoHierarchy?.geoDpCode },
        { key: 'pays', value: geoHierarchy?.countryId },
        // model targeting
        { key: 'idtt', value: getTransactionType(searchModel) },
        { key: 'idtypebien', value: getLegacyEstateTypes(searchModel).join(',') },
        { key: 'naturebien', value: getProjectTypeLegacy(searchModel) },
        { key: 'pxmax', value: roundPrice(searchModel?.priceMax, isRent) },
        { key: 'pxmin', value: roundPrice(searchModel?.priceMin, isRent) },
        { key: 'nb_pieces', value: searchModel?.numberOfRoomsMin },
        { key: 'surfacemax', value: searchModel?.spaceMax },
        { key: 'surfacemin', value: searchModel?.spaceMin },
        { key: 'sur_terrainmax', value: searchModel?.plotSpaceMax },
        { key: 'sur_terrainmin', value: searchModel?.plotSpaceMin },
        { key: 'si_parking', value: searchModel?.featuresIncluded?.includes(FeatureType.PARKING_GARAGE) ? 1 : 0 },
        { key: 'DPE', value: searchModel?.energyCertificateClass?.join(',') },
    ];
};
